const APP_KEY = 'App-ID' as string

export const getAppKey = (): string | null => {
  return window.localStorage.getItem(APP_KEY)
}

export const saveAppKey = (ID: string): void => {
  window.localStorage.setItem(APP_KEY, ID)
}

export const destroyAppKey = (): void => {
  window.localStorage.removeItem(APP_KEY)
}

export default { getAppKey, saveAppKey, destroyAppKey }
